// services/courseService.js

import axios from "axios";
import configuration from "@/utils/configuration";

export const courseService = {

//  ---------------- For General User ----------------

getAllCourse() {
  return axios.get(`${configuration.backUrl}/course`,null);
},

fetchCourseById(courseId) {
  return axios.get(`${configuration.backUrl}/course/details`, {
    params: { course_id: courseId },
  });
},

fetchShortCourseById(courseId) {
  return axios.get(`${configuration.backUrl}/course/short-course/details`, {
    withCredentials: true,
    params: { course_id: courseId },
  });
},

fetchCourseByType(courseTypeId) {
  return axios.get(`${configuration.backUrl}/course-type/courses`, {
    params: { course_type_id: courseTypeId },
  });
},

fetchCourseByCategory(categoryId) {
  return axios.get(`${configuration.backUrl}/category/courses`, {
    params: { category_id: categoryId },
  });
},

getFilteredCourse(payload) {
  return axios.get(`${configuration.backUrl}/course/filter`, {
    params: payload,
  });
},
patchCourseImg(courseId,payload) {
  return axios.patch(`${configuration.backUrl}/course/course-image`,payload, {
    params: {course_id:courseId},
  });
},
deleteCourseImg(courseId) {
  return axios.delete(`${configuration.backUrl}/course/course-image`,{
    params: {course_id:courseId},
  });
},


// ---------------- For Coach Management ----------------

getCourseCoachByCourseId(courseId) {
  return axios.get(`${configuration.backUrl}/course-coach/course`, {
    withCredentials: true,
    params: { course_id: courseId },
  });
},

postCourseCoach(payload) {
  return axios.post(`${configuration.backUrl}/course-coach`, payload, {
    withCredentials: true,
  });
},

patchCourseCoach(courseCoachId, payload) {
  return axios.patch(`${configuration.backUrl}/course-coach`, payload, {
    withCredentials: true,
    params: { course_coach_id: courseCoachId },
  });
},

deleteCourseCoach(courseCoachId) {
  return axios.delete(`${configuration.backUrl}/course-coach`, {
    withCredentials: true,
    params: { course_coach_id: courseCoachId },
  });
},


//  ---------------- For Admin Only ----------------
getAdminFilteredCourse(params) {
  return axios.get(`${configuration.backUrl}/course/management/courses`, {
    withCredentials: true,
    params: params,
  });
},
getCourseReportList() {
  return axios.get(`${configuration.backUrl}/course/management/courses/summary`, {
    withCredentials: true,
  });
},

postGeneralCourse(payload) {
  return axios.post(`${configuration.backUrl}/course`, payload, {
    withCredentials: true,
  });
},

patchGeneralCourse(courseId, payload) {
  return axios.patch(`${configuration.backUrl}/course`, payload, {
    withCredentials: true,
    params: { course_id: courseId },
  });
},

deleteCourse(courseId) {
  return axios.delete(`${configuration.backUrl}/course/management`, {
    withCredentials: true,
    params: { course_id: courseId },
  });
},

patchCourseStatus(courseId, status) {
  return axios.patch(`${configuration.backUrl}/course/update-status`, null, {
    withCredentials: true,
    params: { course_id: courseId, status},
  });
},

// ---------------- Show Student In Class ------------------------------

getStudentViewFilter(courseId) {
  return axios.get(`${configuration.backUrl}/course/management/student-class/filter-option`, {
    withCredentials: true,
    params: { course_id: courseId},
  });
},
getclassViewFilter(courseId) {
  return axios.get(`${configuration.backUrl}/course/management/student-study/filter-option`, {
    withCredentials: true,
    params: { course_id: courseId},
  });
},

// --------------- Reserve Management -----------------------
patchConfirmReserve(params) {
  return axios.patch(`${configuration.backUrl}/reserve/confirm`,null, {
    withCredentials: true,
    params:params,
  });
},

// ---------------- For Course Export File (Admin Only) ----------------

getExportCurrentStudent(params) {
  return axios.get(`${configuration.backUrl}/course/management/student-study/export`, {
    withCredentials: true,
    responseType: 'blob',
    params: params,
  });
},

getExportReserveStudent(params) {
  return axios.get(`${configuration.backUrl}/course/management/student-reserve/export`,{
    withCredentials: true,
    responseType: 'blob',
    params: params,
  });
},

getExportrCompleteStudent(params) {
  return axios.get(`${configuration.backUrl}/course/management/student-complete/export`, {
    withCredentials: true,
    responseType: 'blob',
    params:params,
  });
},


// ---------------- For Package Management ----------------

fetchCoursePackage(courseId) {
  return axios.get(`${configuration.backUrl}/course/course-package-option`, {
    withCredentials: true,
    params: { course_id: courseId },
  });
},

getPackageOptionByCourseId(courseId) {
  return axios.get(`${configuration.backUrl}/course/packages/course-package-options`, {
    withCredentials: true,
    params: { course_id: courseId },
  });
},

fetchCoursePackageOption({ courseId, packageId }) {
  return axios.get(`${configuration.backUrl}/packages/details`, {
    withCredentials: true,
    params: {
      course_id: courseId,
      package_id: packageId,
    },
  });
},

fetchCoursePackageAndOption(courseId) {
  return axios.get(`${configuration.backUrl}/course/package-option`, {
    withCredentials: true,
    params: { course_id: courseId },
  });
},

postPackageOption(payload) {
  return axios.post(`${configuration.backUrl}/course/package-option`, payload, {
    withCredentials: true,
  });
},

patchPackageOption(coursePackageOptionId, payload) {
  return axios.patch(`${configuration.backUrl}/course/management/general-course/package-option`, payload, {
    withCredentials: true,
    params: { course_package_option_id: coursePackageOptionId },
  });
},
patchPrivilageImg(courseId, payload) {
  return axios.patch(`${configuration.backUrl}/course/course-privilege`, payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { course_id: courseId },
  });
},
deletePrivilageImg(courseId) {
  return axios.delete(`${configuration.backUrl}/course/course-privilege`,{
    withCredentials: true,
    params: { course_id: courseId },
  });
},

deletePackageOption(coursePackageOptionId) {
  return axios.delete(`${configuration.backUrl}/course/package-option`, {
    withCredentials: true,
    params: { course_package_option_id: coursePackageOptionId },
  });
},

deleteCoursepackage(courseId, packageId) {
  return axios.delete(`${configuration.backUrl}/course/package`, {
    withCredentials: true,
    params: { course_id: courseId, package_id: packageId },
  });
},

//-----------  Learning Journey Management ------------
patchJourneyImg(courseId, payload) {
  return axios.patch(`${configuration.backUrl}/course/learning-journey`, payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { course_id: courseId },
  });
},
deleteJourneyImg(learningJourneyId) {
  return axios.delete(`${configuration.backUrl}/course/learning-journey`,{
    withCredentials: true,
    params: { learning_journey_id: learningJourneyId },
  });
},
getJourneyImg(courseId) {
  return axios.get(`${configuration.backUrl}/course/learning-journey`,{
    withCredentials: true,
    params: { course_id: courseId },
  });
},


};

